module.exports = __webpack_public_path__ + "/login_ui/img/nl-2852180048fb477511af5bcc67a674c2.svg";